/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

import { isEmpty } from "lodash-es";
import { Row, Col, ColCard } from "../../components/ContentLayout";
import DataComponent from "../../components/DataComponent";
import { classnames } from "../../utils/text";
import Icon from "../../components/Icon";

// icon
import barChartIcon from "../../assets/images/icon/bar-chart-icon.svg";
import smallMenuIcon from "../../assets/images/icon/small-menu-icon.svg";
import financeIcon from "../../assets/images/icon/finance-icon.svg";
import StatisticsBoard from "./StatisticsBoard";
import ReminderBoard from "./ReminderBoard";
// import AccountsBoard from "./AccountsBoard";
import AttendanceBoard from "./AttendanceBoard";
import AttendanceStatusBoard from "./AttendanceStatusBoard";
import NoticeWriteBoard from "./NoticeWriteBoard";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import queryString from "query-string";
import { ADMIN_TYPES, ALL_TYPES, TAX_ADMIN_TYPES } from "../../constants/ROLE";
import BankAccountList from "../Funds/AccountDetail/BankList";
import BankAccountByUseConfirmList from "../Funds/AccountDetail/BankListByUseConfirm";

// Board
// ADMIN = 관리자, SUB_ADMIN = 경리 , NORMAL = 일반유저
const dashbaordAllList = [
  {
    roles: ADMIN_TYPES,
    label: "통계보드",
    id: "STATISTICS_BOARD",
    icon: barChartIcon,
    Board: StatisticsBoard,
    isTrial: false
  },
  {
    roles: ALL_TYPES,
    label: "알림보드",
    id: "REMINDER_BOARD",
    icon: smallMenuIcon,
    Board: ReminderBoard,
    isTrial: true
  },
  {
    roles: TAX_ADMIN_TYPES,
    label: "매핑안된 내역",
    id: "MAPPING_BOARD",
    icon: financeIcon,
    Board: BankAccountList,
    isTrial: false
  },
  {
    roles: ADMIN_TYPES,
    label: "내역확인요청",
    id: "USE_CONFIRM_BOARD",
    icon: financeIcon,
    Board: BankAccountByUseConfirmList,
    isTrial: false
  },
];

const Dashboard = (props) => {
  // const role = "ADMIN";
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const { employee, role, isManaging, company } = useSelector((store) => store.Profile);
  const [activeTab, setActiveTab] = useState(null);
  const [tabList, setTabList] = useState(null);
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setTargetPermission(permissions.find(p => p.code === 'FUND_BANK_HISTORY'));
    }

  }, [permissions]);

  const _setActiveTab = (id) => {
    history.push({
      search: `?tab=${id}`
    });
    setActiveTab(id);
  };

  useEffect(() => {
    if (company) {
      const _type = (!isEmpty(role)) ? role.type : 5;
      const _tabList = dashbaordAllList.filter(dashbaord =>
        company.isTrial ? dashbaord.isTrial : dashbaord.roles.includes(_type)
      );
      setTabList(_tabList);
      const query = queryString.parse(history.location.search);
      setActiveTab(query.tab || _tabList[0].id);
    }
  }, [history.location, role, company]);

  return (
    <div className="dashboard-page">
      {employee && employee.name && <>
        <PageHeader title={`${employee && employee.name}님, 안녕하세요`} />
        <div className="dashboard-container">
          <div className="dashboard-inner">

            <div className="dashboard-content">
              {!isEmpty(tabList) && (
                <>
                  <Row>
                    <ColCard type="light" className={"dashboard-tab"}>
                      {tabList.map(({ label, icon, id }, idx) => (
                        <DataComponent
                          key={idx}
                          field={{
                            className: classnames({
                              active: activeTab === id,
                            }),
                            type: "button",
                            color: "text",
                            label: (
                              <>
                                <Icon src={icon} />
                                {label}
                              </>
                            ),
                            action: () => {
                              _setActiveTab(id);
                            },
                          }}
                        />
                      ))}
                    </ColCard>
                  </Row>
                  {tabList.map(({ label, Board, id }, idx) => (
                    <React.Fragment key={idx}>
                      {id === activeTab ? <Board permission={targetPermission} clientRegistered /> : <></>}
                    </React.Fragment>
                  ))}
                </>
              )}
            </div>
            {/* contents Right */}
            <div className="dashboard-aside">
              <Col>
                {!isManaging &&
                  <Row>
                    <AttendanceBoard />
                  </Row>
                }
                <Row>
                  <AttendanceStatusBoard />
                </Row>
                {
                  role && ADMIN_TYPES.includes(role.type) &&
                  <Row>
                    <NoticeWriteBoard />
                  </Row>
                }
              </Col>
            </div>
          </div>
        </div>
      </>
      }
    </div>
  );
};

export default Dashboard;
